export const updatePricingState = function (statesAndValues = []) {
  const quotePricing = { ...this.state.quotePricing }
  statesAndValues.forEach(stateAndValue => {
    quotePricing[stateAndValue.state] = stateAndValue.value
  })
  this.setState({ quotePricing })
}
